import React from "react";

const SpanFailed = ({ text }) => {
  return (
    <span className="inline-block rounded-[12px] h-[24px] w-[68px] text-tenken-tablet-regular bg-[#FA5252] text-center text-white">
      {text}
    </span>
  );
};

export default SpanFailed;
